'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var hashlru = require('hashlru');
/**
 * Time Aware Least Recent Used Cache
 * @see https://arxiv.org/pdf/1801.00390
 * @todo move this to ipfs-utils or it's own package
 *
 * @class TLRU
 */


var TLRU = /*#__PURE__*/function () {
  /**
   * Creates an instance of TLRU.
   *
   * @param {number} maxSize
   * @memberof TLRU
   */
  function TLRU(maxSize) {
    _classCallCheck(this, TLRU);

    this.lru = hashlru(maxSize);
  }
  /**
   * Get the value from the a key
   *
   * @param {string} key
   * @returns {any}
   * @memberof TLRU
   */


  _createClass(TLRU, [{
    key: "get",
    value: function get(key) {
      var value = this.lru.get(key);

      if (value) {
        if (value.expire && value.expire < Date.now()) {
          this.lru.remove(key);
          return undefined;
        }

        return value.value;
      }

      return undefined;
    }
    /**
     * Set a key value pair
     *
     * @param {string} key
     * @param {any} value
     * @param {number} ttl - in miliseconds
     * @memberof TLRU
     */

  }, {
    key: "set",
    value: function set(key, value, ttl) {
      this.lru.set(key, {
        value: value,
        expire: Date.now() + ttl
      });
    }
    /**
     * Find if the cache has the key
     *
     * @param {string} key
     * @returns {boolean}
     * @memberof TLRU
     */

  }, {
    key: "has",
    value: function has(key) {
      var value = this.get(key);

      if (value) {
        return true;
      }

      return false;
    }
    /**
     * Remove key
     *
     * @param {string} key
     * @memberof TLRU
     */

  }, {
    key: "remove",
    value: function remove(key) {
      this.lru.remove(key);
    }
    /**
     * Clears the cache
     *
     * @memberof TLRU
     */

  }, {
    key: "clear",
    value: function clear() {
      this.lru.clear();
    }
  }]);

  return TLRU;
}();

module.exports = TLRU;